import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

export const RETRIEVAL_MODE_LATEST = 'latest' as const;
export const RETRIEVAL_MODE_ALL = 'all' as const;
export type RetrievalMode = typeof RETRIEVAL_MODE_LATEST | typeof RETRIEVAL_MODE_ALL;

/**
 * In-memory preference for retrieval mode toggle.
 * Toggle OFF (default) → "latest"; toggle ON → "all".
 * Survives session/agent switches within the same page load; resets on full refresh.
 */
@Injectable({
  providedIn: 'root'
})
export class RetrievalModePreferenceService {
  private readonly allVersionsEnabledSubject = new BehaviorSubject<boolean>(false);
  readonly allVersionsEnabled$: Observable<boolean> = this.allVersionsEnabledSubject.asObservable();

  isAllVersionsEnabled(): boolean {
    return this.allVersionsEnabledSubject.getValue();
  }

  setAllVersionsEnabled(value: boolean): void {
    this.allVersionsEnabledSubject.next(value);
  }

  getRetrievalMode(): RetrievalMode {
    return this.isAllVersionsEnabled() ? RETRIEVAL_MODE_ALL : RETRIEVAL_MODE_LATEST;
  }
}
